var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallEnd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.41716 12.126L6.39349 12.126C7.81361 12.126 8.73666 10.6349 8.09763 9.42782C7.67157 8.57572 8.0266 7.51063 8.80769 7.01362C10.5828 5.94853 14.3462 5.87752 16.1923 7.01362C17.0444 7.43968 17.3284 8.57578 16.9024 9.42782C16.2633 10.6349 17.1864 12.126 18.6065 12.126L22.5828 12.126C23.6479 12.055 24.5 11.203 24.5 10.2089L24.5 7.51066C24.429 4.74143 19.1746 2.46924 12.5 2.46924C5.82544 2.46924 0.499972 4.67039 0.5 7.51066L0.5 10.2089C0.570979 11.274 1.42305 12.1261 2.41716 12.126Z",
    fill: "rgba(0, 0, 0, 0.2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.500488)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEnd);
export default __webpack_public_path__ + "static/media/call_end.5ee1b31c5f7098eb56714a58b896103d.svg";
export { ForwardRef as ReactComponent };